// extracted by mini-css-extract-plugin
module.exports = {"user":"biostyle-module--user--2yegu","description":"biostyle-module--description--hS1E5","avatar":"biostyle-module--avatar--3FR2O","excerpt":"biostyle-module--excerpt--3TJS1"};